import React from "react";

import { useTheme } from "styled-components";

import Icon, { getIconType } from "../../../../../components/ui/icon/Icon";
import Time from "../../timer/Time";
import EditableText from "../../inline-edit/EditableText";
import EditableLine from "../../inline-edit/EditableLine";
import getReadableColor from "../../../../../components/ui/color-picker/getReadableColor";
import {
  Button,
  Emoji,
  IconEmojiContainer,
  IconText,
  Text,
  TimerButton,
  Title,
  TitleText,
  Wrapper,
} from "./style";
import { urlValidator } from "../../../../../helpers/validators";
import { shadeColor } from "../../../../../helpers/shade-color";

function CustomColor({ data, isEditable, viewMode = "view" }) {
  const {
    title,
    text,
    colorFields,
    timerLayout,
    time,
    url,
    newTab,
    icon,
    borderRadius,
    linkText,
    colorMute,
  } = data;

  const iconType = getIconType(icon);

  const theme = useTheme();

  const checkLayout = (prop) =>
    !!timerLayout.find((item) => item.value === prop);

  const color = colorFields.Timer[theme.name];
  const bgMuted = `${color.slice(0, 7)}4d`;
  const textMuted = shadeColor(color, -70);

  return (
    <Wrapper
      borderRadius={borderRadius}
      color={colorMute ? bgMuted : color}
      onClick={(e) => {
        if (checkLayout("label")) return;
        if (
          viewMode === "view" &&
          urlValidator({ url: url?.link, protocols: ["https:"] })
        )
          window.open(url?.link, newTab ? "_blank" : "_top");
      }}
    >
      <IconText>
        {checkLayout("icon") && (
          <IconEmojiContainer
            clr={colorMute ? textMuted : getReadableColor(color)}
          >
            {iconType === "emoji" && <Emoji>{icon.native}</Emoji>}

            {iconType === "icon" && <Icon icon={icon} size="35px" />}

            {iconType === "app" && <img src={icon} alt="img" height="35px" />}
          </IconEmojiContainer>
        )}

        <TitleText clr={colorMute ? textMuted : getReadableColor(color)}>
          <Title hasText={checkLayout("text")}>
            <EditableText
              isEditable={isEditable}
              value={title}
              propKey="title"
              customCalculatorStyles={{ minHeight: "1em" }}
            />
          </Title>
          {checkLayout("text") && (
            <Text>
              <EditableText
                isEditable={isEditable}
                value={text}
                propKey="text"
              />
            </Text>
          )}
        </TitleText>
      </IconText>

      <TimerButton>
        <Time
          time={time}
          color={colorMute ? textMuted : getReadableColor(color)}
        />
        {checkLayout("label") && (
          <Button
            bgClr={colorMute ? color : getReadableColor(color)}
            clr={colorMute ? getReadableColor(color) : color}
            onClick={() => {
              if (
                viewMode === "view" &&
                urlValidator({ url: url?.link, protocols: ["https:"] })
              )
                window.open(url?.link, newTab ? "_blank" : "_top");
            }}
          >
            <EditableLine
              value={linkText}
              isEditable={isEditable}
              propKey="linkText"
            />
          </Button>
        )}
      </TimerButton>
    </Wrapper>
  );
}

export default CustomColor;
